export default __webpack_public_path__ + "static/media/killer-whale.0df42ea1.png";